// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__sK8N-","categories__content":"Categories_categories__content__+F0i-"};